import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { trimSlashes } from '../../../ui/src/utilities';
import Api from '../../../ui/src/api.js';
import Popup from '../popup/popup';

class CsmSectionLink extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      popupOpened: false,
    };
  }
  render() {
    let url = `/sekcia/${this.props.section._id}`;
    if (this.props.section.url) {
      url = `/${trimSlashes(this.props.section.url)}`;
    }
    if (Object.keys(this.props.params).length > 0) {
      url = `${url}?${Api.objectToParams(this.props.params)}`;
    }
    if (this.props.section.redirecturl) {
      return (
        <a href={this.props.section.redirecturl}>
          {this.props.children || this.props.section.name}
        </a>
      );
    } else if (this.props.nested) {
      return (
        <div style={{ position: 'relative' }}>
          <a
            className="popup-trigger"
            href=""
            onClick={(e) => {
              e.preventDefault();
              this.setState({
                popupOpened: !this.state.popupOpened,
              });
            }}
          >
            {this.props.children || this.props.section.name}&nbsp;<span
              className={`chevron ${this.state.popupOpened ? 'inverted' : ''}`}
            />
          </a>

          <div className="popup-container">
            {this.props.sections.length !== 0 && (
              <Popup
                eventTypes="click"
                opened={this.state.popupOpened}
                onClickItem={() => {
                  this.setState({ popupOpened: false });
                }}
                items={this.props.sections.map(item => (
                  <CsmSectionLink section={item} />
                ))}
                handleClickOutside={() => this.setState({ popupOpened: false })}
                outsideClickIgnoreClass={'popup-trigger'}
              />
            )}
          </div>
        </div>
      );
    } else {
      return (
        <Link to={url} target={this.props.target}>
          {this.props.children || this.props.section.name}
        </Link>
      );
    }
  }
}

CsmSectionLink.defaultProps = {
  params: {},
  nested: false,
  sections: [],
};

CsmSectionLink.propTypes = {
  section: PropTypes.object.isRequired,
  children: PropTypes.node,
  target: PropTypes.string,
  nested: PropTypes.bool,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    }),
  ),
  params: PropTypes.object, // additional GET parameters
};

export default CsmSectionLink;



// WEBPACK FOOTER //
// ./src/app/component/csmSectionLink/csmSectionLink.js